export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/icon_must_verify_email-01bf9df1b264688bed592a8a377cfe0c.svg";